//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const DisplayNameForUsers: FeatureFlag = {"Id":"DisplayNameForUsers","Label":"[10.10]Use Display Name, not First/Last Name in Users","Impact":"Shows the user column instead of the first and names columns in Users","Mode":3,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
